import { render, staticRenderFns } from "./VimeoVideo.vue?vue&type=template&id=db710442&scoped=true&"
import script from "./VimeoVideo.vue?vue&type=script&lang=js&"
export * from "./VimeoVideo.vue?vue&type=script&lang=js&"
import style0 from "./VimeoVideo.vue?vue&type=style&index=0&id=db710442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db710442",
  null
  
)

export default component.exports